import { ErrorBoundary } from '@advanza/ui'
import NiceModal from '@ebay/nice-modal-react'
import { ToastProvider } from '@trustoo/components/ui/toaster/ToastContext'
import { store } from 'app/store'
import AdSheetsPage from 'components/adSheets/AdSheetsPage'
import ApisPage from 'components/apis/ApisPage'
import DemandAppAnalyticsPage from 'components/appAnalytics/DemandAppAnalyticsPage'
import SupplyAppAnalyticsPage from 'components/appAnalytics/SupplyAppAnalyticsPage'
import BansPage from 'components/bans/BansPage'
import BillingRunPage from 'components/billing/billingRun/BillingRunPage'
import DebtorNewPage from 'components/billing/debtorNew/DebtorNewPage'
import ExactImportPage from 'components/billing/ExactImportPage'
import InvoicesPage from 'components/billing/InvoicesPage'
import LostInvoicesPage from 'components/billing/LostInvoicesPage'
import OpenChargesPage from 'components/billing/OpenChargesPage'
import SepaPage from 'components/billing/sepa/SepaPage'
import ChannableFeedPage from 'components/channableFeed/ChannableFeedPage'
import ChurnReasonThemesPage from 'components/churnReasonThemes/ChurnReasonThemesPage'
import CountryPage from 'components/country/CountryPage'
import QueuePage from 'components/dev/QueuePage'
import TestBaseModalPage from 'components/dev/TestBaseModalPage'
import EventFilter from 'components/events/EventFilter'
import EventList from 'components/events/EventList'
import ExpectationSettingsPage from 'components/expectationsettings/ExpectationSettingsPage'
import FreeLeadTypesPage from 'components/freeleadtypes/FreeLeadTypesPage'
import GeoTargetingPage from 'components/geoTargeting/GeoTargetingPage'
import KeywordMappingsPage from 'components/keywordMappings/KeywordMappingsPage'
import ExpertiseKeywordsPage from 'components/keywords/ExpertiseKeywordsPage'
import LeadEstimatorPage from 'components/leadEstimator/LeadEstimatorPage'
import LicencesPage from 'components/licences/LicencesPage'
import LicencesUpdatersPage from 'components/licencesUpdaters/LicencesUpdatersPage'
import LimitReachedPage from 'components/limitReached/LimitReachedPage'
import AnonymizedRequestsPage from 'components/marketing/anonymizedRequests/AnonymizedRequestsPage'
import EmailBuilderPage from 'components/marketing/emailBuilder/EmailBuilderPage'
import MatchingDebuggerPage from 'components/matchingDebugger/MatchingDebuggerPage'
import DesignSystemPage from 'components/misc/designSystem/DesignSystemPage'
import ErIsIetsMisGegaan from 'components/misc/ErIsIetsMisGegaan'
import MiscPage from 'components/misc/MiscPage'
import Toaster, { ToastBridgeConnector } from 'components/misc/Toaster'
import PartnerPushPage from 'components/partnerPush/PartnerPushPage'
import ActivePausesPage from 'components/pauses/ActivePausesPage'
import PopUpNotificationsPage from 'components/popUpNotifications/PopUpNotificationsPage'
import ProviderEditViewPage from 'components/providers/ProviderEditViewPage'
import RedirectsPage from 'components/redirects/RedirectsPage'
import RegionsPage from 'components/regions/RegionsPage'
import AggregatedReviewsPage from 'components/reviews/AggregatedReviewsPage'
import HomePageTestimonialsPage from 'components/reviews/HomePageTestimonialsPage'
import SeoPage from 'components/seo/SeoPage'
import SEOServicesPlacesContentsPage from 'components/seo/SEOServicesPlacesContentsPage'
import QuestionnairesPage from 'components/services/QuestionnairesPage'
import TestPage from 'components/TestPage'
import Page from 'components/ui/Page'
import WinbackOfferSettingsPage from 'components/winbackoffersettings/WinbackOfferSettingsPage'
import SendgridMailsPage from 'mails/SendgridMailsPage'
import changeFavicon from 'misc/changeFavicon'
import React from 'react'
import { IntlProvider } from 'react-intl'
import { Provider } from 'react-redux'
import { Navigate, Route, Routes, useParams } from 'react-router-dom'
import AdminUsersPage from '../components/adminUsers/AdminUsersPage'
import CancellationsPage from '../components/cancellations/CancellationsPage'
import ClosedLoopEmailsPage from '../components/closedLoop/ClosedLoopEmailsPage'
import ClosedLoopRequestsPage from '../components/closedLoop/ClosedLoopRequestsPage'
import DemandUsersPage from '../components/demandUsers/DemandUsersPage'
import EventsPage from '../components/events/EventsPage'
import EventViewPage from '../components/events/EventViewPage'
import LabelsPage from '../components/labels/LabelsPage'
import LoginPage from '../components/LoginPage'
import MatchesPage from '../components/matches/MatchesPage'
import MatchViewPage from '../components/matches/MatchViewPage'
import ProDashboardPage from '../components/proDashboard/ProDashboardPage'
import ProfileBuilderWizardPage from '../components/profileBuilderWizard/ProfileBuilderWizardPage'
import ProvidersBuildersPage from '../components/profileBuilderWizard/ProvidersBuildersPage'
import ProfileReportPage from '../components/profileReport/ProfileReportPage'
import PromosPage from '../components/promos/PromosPage'
import ProvidersPage from '../components/providers/ProvidersPage'
import ProviderViewPage from '../components/providers/ProviderViewPage'
import ProvidersBansPage from '../components/providersBans/ProvidersBansPage'
import ReclaimsPage from '../components/reclaims/ReclaimsPage'
import ReclaimTaskPage from '../components/reclaims/ReclaimTaskPage'
import AiAutoReplyAnalyticsReportPage from '../components/reports/AiAutoReplyAnalyticsReportPage'
import ChatbotAnalyticsReportPage from '../components/reports/ChatbotAnalyticsReportPage'
import FingerprintSignupReportPage from '../components/reports/FingerprintSignupReportPage'
import SubscriptionChurnReportPage from '../components/reports/SubscriptionChurnReportPage'
import WinBackOffersReportPage from '../components/reports/WinBackOffersReportPage'
import RequestsPage from '../components/requests/RequestsPage'
import RequestViewPage from '../components/requests/RequestViewPage'
import SalesLeadsPage from '../components/salesLeads/SalesLeadsPage'
import SalesLeadViewPage from '../components/salesLeads/SalesLeadViewPage'
import ServiceInfoPage from '../components/serviceInfo/ServiceInfoPage'
import ServicesPage from '../components/services/ServicesPage'
import ServiceViewPage from '../components/services/ServiceViewPage'
import StatusesPage from '../components/statuses/StatusesPage'
import SubscriptionPage from '../components/subscriptions/SubscriptionPage'
import ComingSoon from '../components/ui/ComingSoon'
import messages from '../locale/en.json'

window.previousRoute = window.location.pathname
const formats = {
    time: {
        short: {
            hour12: false,
            hour: '2-digit',
            minute: 'numeric',
            month: '2-digit',
            day: '2-digit',
        },
    },
}

const defaultEventQuery = {
    // Add any default query parameters needed for the event list
    page: 1,
    limit: 10,
}

const ChangePasswordWrapper = () => {
    const params = useParams()
    return <LoginPage page="changePassword" email={params.email} token={params.token} />
}

class Root extends React.Component {
    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            window.previousRoute = prevProps.location.pathname
        }
    }

    componentDidMount() {
        if (window.location.hostname !== 'office.trustoo.nl') {
            changeFavicon('/apps/office/test/favicon.ico')
        }
    }

    render() {
        const publicPaths = ['/login', '/two-factor-secret', '/two-factor-one-time-code']
        const isChangePassword = window.location.pathname.startsWith('/change-password')
        const isPublic = publicPaths.includes(window.location.pathname) || isChangePassword
        if (!window._user || !window._user.id) {
            if (!isPublic) {
                window.location.href = '/login?redirect=' + window.location.pathname
                return null
            }
        }
        return (
            <div className={window.isMobile ? 'mobile' : 'desktop'}>
                <Provider store={store}>
                    <ToastProvider>
                        <ToastBridgeConnector />
                        <NiceModal.Provider>
                            <IntlProvider formats={formats} locale="en" messages={messages}>
                                <Routes>
                                    {/* Sales */}
                                    <Route path="/" element={<ComingSoon />} />
                                    <Route path="/test" element={<TestPage />} />
                                    <Route path="/sales" element={<ComingSoon />} />
                                    <Route path="/sales/leads" element={<SalesLeadsPage />} />
                                    <Route
                                        path="/sales/leads/lead/:id"
                                        element={<SalesLeadViewPage />}
                                    />
                                    <Route path="/sales/account" element={<ComingSoon />} />
                                    <Route
                                        path="/sales/site-info/:id?"
                                        element={<ServiceInfoPage />}
                                    />
                                    <Route path="/sales/lukewarm" element={<ComingSoon />} />
                                    <Route path="/sales/opportunities" element={<ComingSoon />} />
                                    <Route
                                        path="/sales/lead-estimator/:serviceId?/:subscriptionId?"
                                        element={<LeadEstimatorPage />}
                                    />

                                    {/* Client service */}
                                    <Route path="/service/requests" element={<RequestsPage />} />
                                    <Route
                                        path="/service/requests/request/:id"
                                        element={<RequestViewPage />}
                                    />

                                    <Route path="/service/matches" element={<MatchesPage />} />
                                    <Route
                                        path="/service/matches/match/:id"
                                        element={<MatchViewPage />}
                                    />

                                    <Route path="/service/events" element={<EventsPage />} />
                                    <Route
                                        path="/service/events/event/:id"
                                        element={<EventViewPage />}
                                    />

                                    <Route
                                        path="/settings/matching-debugger/"
                                        element={<MatchingDebuggerPage />}
                                    />

                                    <Route
                                        path="/service/profile-report"
                                        element={<ProfileReportPage />}
                                    />

                                    <Route path="/service/providers" element={<ProvidersPage />} />
                                    <Route
                                        path="/service/providers/provider/edit/:id?"
                                        element={<ProviderEditViewPage />}
                                    />
                                    <Route
                                        path="/service/providers/provider/:id?/:tab?"
                                        element={<ProviderViewPage />}
                                    />
                                    <Route
                                        path="/service/providers/subscription/:id?"
                                        element={<SubscriptionPage />}
                                    />

                                    <Route
                                        path="/service/demand-users"
                                        element={<DemandUsersPage />}
                                    />
                                    <Route
                                        path="/service/cancellations"
                                        element={<CancellationsPage />}
                                    />
                                    <Route
                                        path="/service/limit-reached"
                                        element={<LimitReachedPage />}
                                    />
                                    <Route
                                        path="/service/active-pauses"
                                        element={<ActivePausesPage />}
                                    />
                                    <Route
                                        path="/service/profile-builder-wizard/:id?/:page?"
                                        element={
                                            <ErrorBoundary
                                                slackOptions={{
                                                    emoji: ':male_mage:',
                                                    username: 'Profile Builder Wizard',
                                                }}>
                                                <ProfileBuilderWizardPage />
                                            </ErrorBoundary>
                                        }
                                    />
                                    <Route
                                        path="/service/providers-builders"
                                        element={<ProvidersBuildersPage />}
                                    />
                                    <Route
                                        path="/statistics/closed-loop-emails"
                                        element={<ClosedLoopEmailsPage />}
                                    />
                                    <Route
                                        path="/statistics/closed-loop-requests"
                                        element={<ClosedLoopRequestsPage />}
                                    />
                                    <Route
                                        path="/statistics/closed-loop-requests/:source/request/:id"
                                        element={<RequestViewPage />}
                                    />

                                    <Route path="/billing/open" element={<OpenChargesPage />} />
                                    <Route path="/billing/run" element={<BillingRunPage />} />
                                    <Route path="/billing/sepa" element={<SepaPage />} />
                                    <Route path="/billing/invoices" element={<InvoicesPage />} />
                                    <Route
                                        path="/billing/lost-invoices"
                                        element={<LostInvoicesPage />}
                                    />
                                    <Route
                                        path="/billing/debtors"
                                        element={<Navigate to="/billing/debtor-new" replace />}
                                    />
                                    <Route path="/billing/debtor-new" element={<DebtorNewPage />} />
                                    <Route
                                        path="/billing/exact-export"
                                        element={<ExactImportPage />}
                                    />
                                    <Route path="/billing/reclaims" element={<ReclaimsPage />} />
                                    <Route
                                        path="/billing/reclaim-tasks"
                                        element={<ReclaimTaskPage />}
                                    />
                                    <Route
                                        path="/billing/quarantined"
                                        element={<ProvidersBansPage />}
                                    />
                                    <Route path="/billing/bans" element={<BansPage />} />

                                    <Route path="/settings/licences" element={<LicencesPage />} />
                                    <Route
                                        path="/settings/licences-updaters"
                                        element={<LicencesUpdatersPage />}
                                    />
                                    <Route path="/settings/services" element={<ServicesPage />} />
                                    <Route path="/settings/seo" element={<SeoPage />} />
                                    <Route
                                        path="/settings/seo/services-places-contents"
                                        element={<SEOServicesPlacesContentsPage />}
                                    />
                                    <Route
                                        path="/settings/expertise-keywords"
                                        element={<ExpertiseKeywordsPage />}
                                    />
                                    <Route
                                        path="/settings/services/service/:id"
                                        element={<ServiceViewPage />}
                                    />
                                    <Route
                                        path="/settings/services/service/:id/questions"
                                        element={<QuestionnairesPage />}
                                    />
                                    <Route path="/settings/country" element={<CountryPage />} />
                                    <Route path="/settings/regions" element={<RegionsPage />} />
                                    <Route
                                        path="/settings/reviews"
                                        element={<HomePageTestimonialsPage />}
                                    />
                                    <Route
                                        path="/settings/review-sources"
                                        element={<AggregatedReviewsPage />}
                                    />
                                    <Route path="/settings/labels" element={<LabelsPage />} />
                                    <Route path="/settings/statuses" element={<StatusesPage />} />
                                    <Route
                                        path="/settings/marketing-promos"
                                        element={<PromosPage />}
                                    />
                                    <Route
                                        path="/settings/admin-users"
                                        element={<AdminUsersPage />}
                                    />

                                    <Route
                                        path="/settings/pro-dashboard"
                                        element={<ProDashboardPage />}
                                    />

                                    <Route path="/settings/apis" element={<ApisPage />} />
                                    <Route
                                        path="/settings/partner-request-push"
                                        element={<PartnerPushPage />}
                                    />

                                    <Route
                                        path="/ads/channable-feed"
                                        element={<ChannableFeedPage />}
                                    />

                                    <Route
                                        path="/settings/provider-notifications"
                                        element={<PopUpNotificationsPage />}
                                    />

                                    <Route
                                        path="/settings/winback-offers"
                                        element={<WinbackOfferSettingsPage />}
                                    />

                                    <Route
                                        path="/settings/free-lead-types"
                                        element={<FreeLeadTypesPage />}
                                    />

                                    <Route
                                        path="/settings/churn-reason-themes"
                                        element={<ChurnReasonThemesPage />}
                                    />

                                    <Route path="/ads/adsheets" element={<AdSheetsPage />} />

                                    <Route
                                        path="/ads/expectation-settings"
                                        element={<ExpectationSettingsPage />}
                                    />

                                    <Route
                                        path="/ads/keyword-mappings"
                                        element={<KeywordMappingsPage />}
                                    />

                                    <Route
                                        path="/ads/geo-targeting"
                                        element={<GeoTargetingPage />}
                                    />

                                    <Route path="/sendgrid-mails" element={<SendgridMailsPage />} />

                                    <Route
                                        path="/marketing/email-builder"
                                        element={<EmailBuilderPage />}
                                    />

                                    <Route
                                        path="/marketing/anonymized-requests"
                                        element={<AnonymizedRequestsPage />}
                                    />

                                    <Route path="/login" element={<LoginPage notRestricted />} />
                                    <Route
                                        path="/two-factor-secret"
                                        element={<LoginPage notRestricted page="twoFactorSecret" />}
                                    />
                                    <Route
                                        path="/two-factor-one-time-code"
                                        element={
                                            <LoginPage notRestricted page="twoFactorOneTimeCode" />
                                        }
                                    />
                                    <Route
                                        path="/change-password/:token?/:email?"
                                        element={<ChangePasswordWrapper />}
                                    />
                                    <Route
                                        path="/logout"
                                        element={<LoginPage notRestricted page="logout" />}
                                    />
                                    <Route
                                        path="/reports/subscription-churn"
                                        element={<SubscriptionChurnReportPage />}
                                    />
                                    <Route
                                        path="/reports/win-back-offers"
                                        element={<WinBackOffersReportPage />}
                                    />
                                    <Route
                                        path="/reports/fingerprint-signup"
                                        element={<FingerprintSignupReportPage />}
                                    />
                                    <Route
                                        path="/reports/chatbot-analytics"
                                        element={<ChatbotAnalyticsReportPage />}
                                    />
                                    <Route
                                        path="/reports/ai-auto-reply-analytics"
                                        element={<AiAutoReplyAnalyticsReportPage />}
                                    />
                                    <Route
                                        path="/app-analytics/supply"
                                        element={<SupplyAppAnalyticsPage />}
                                    />
                                    <Route
                                        path="/app-analytics/demand"
                                        element={<DemandAppAnalyticsPage />}
                                    />
                                    <Route
                                        path="/app-analytics"
                                        element={<Navigate to="/app-analytics/supply" replace />}
                                    />
                                    <Route path="/misc/redirects" element={<RedirectsPage />} />
                                    <Route
                                        path="/design-system/foundations"
                                        element={<DesignSystemPage section="foundations" />}
                                    />
                                    <Route
                                        path="/design-system/components"
                                        element={<DesignSystemPage section="components" />}
                                    />
                                    <Route
                                        path="/design-system"
                                        element={
                                            <Navigate to="/design-system/foundations" replace />
                                        }
                                    />
                                    <Route
                                        path="/misc/design-system"
                                        element={
                                            <Navigate to="/design-system/foundations" replace />
                                        }
                                    />
                                    <Route path="/misc" element={<MiscPage />} />
                                    <Route
                                        path="/er-is-iets-misgegaan"
                                        element={<ErIsIetsMisGegaan />}
                                    />
                                    <Route
                                        path="/events/event-list"
                                        element={
                                            <Page>
                                                <EventFilter
                                                    filterId="eventList"
                                                    defaultOptions={defaultEventQuery}
                                                />
                                                <EventList filterId="eventList" />
                                            </Page>
                                        }
                                    />
                                    <Route path="/dev/queue" element={<QueuePage />} />
                                    <Route path="/dev/modal" element={<TestBaseModalPage />} />
                                    <Route path="*" element={<ComingSoon />} />
                                </Routes>
                                <Toaster />
                            </IntlProvider>
                        </NiceModal.Provider>
                    </ToastProvider>
                </Provider>
                <canvas
                    style={{ position: 'fixed', opacity: 0, zIndex: -111 }}
                    id="svgToPngCanvas"></canvas>
            </div>
        )
    }
}

export default Root
